<template>
  <grid-layout
    :layout.sync="layout"
    :col-num="12"
    :row-height="30"
    :is-draggable="false"
    :is-resizable="false"
    :vertical-compact="true"
    :responsive="true"
    :margin="[15, 15]"
    :use-css-transforms="true"
    :cols="{ lg: 12, md: 12, sm: 1, xs: 1, xxs: 1 }"
  >
    <grid-item v-for="item in layout" :x="item.x" :y="item.y" :w="item.w" :h="item.h" :i="item.i" :key="item.i">
      <q-card class="fit" bordered flat :style="`border-color: ${item.color}`">
        <q-toolbar class="q-px-sm q-pt-sm" v-if="item.title">
          <q-toolbar-title class="text-subtitle2 text-weight-medium">
            {{ $t(item.title) }}
          </q-toolbar-title>
          <q-icon :name="item.icon" size="sm" :style="`color: ${item.color}`" />
        </q-toolbar>
        <component :is="item.component" :data="item" />
      </q-card>
    </grid-item>
  </grid-layout>
</template>

<script>
import { GridLayout, GridItem } from 'vue-grid-layout';
import SlideShow from '@/components/dashboard/cards/SlideShow.vue';
import DashboardResume from '../../services/DashboardResume';
import SingleCard from '@/components/dashboard/cards/SingleCard.vue';
import ListCampaignsAffiliate from '@/components/dashboard/lists/ListCampaignsAffiliate.vue';
import ListCampaignsExclusive from '@/components/dashboard/lists/ListCampaignsExclusive.vue';
import ListCampaignsMain from '@/components/dashboard/lists/ListCampaignsMain.vue';
import BarChartCard from '@/components/dashboard/cards/BarChartCard.vue';

export default {
  name: 'DashboardAffiliate',
  mixins: [DashboardResume],
  components: {
    GridLayout,
    GridItem,
    SlideShow,
    SingleCard,
    ListCampaignsAffiliate,
    ListCampaignsExclusive,
    ListCampaignsMain,
    BarChartCard
  },
  props: {
    summary: {
      type: Object,
      default: () => ({})
    },
    campaignMetrics: {
      type: Array,
      default: () => []
    },
    exclusiveCampaigns: {
      type: Array,
      default: () => []
    },
    mainCampaigns: {
      type: Object,
      default: () => ({ higherCommission: [], convertMore: [] })
    }
  },

  watch: {
    summary: {
      handler() {
        this.layout[1].extras.fullValue = `${this.parseMoney(this.summary.conversionValue)}` || 'R$ 0,00';
        this.layout[2].extras.fullValue = `${this.parseMoney(this.summary.commissionValue)}` || 'R$ 0,00';
        this.layout[3].extras.fullValue = this.summary.conversionAmount || '0';
      },
      deep: true,
      immediate: true
    },
    campaignMetrics: {
      handler() {
        this.layout[4].data = this.campaignMetrics || [];
      },
      deep: true,
      immediate: true
    },
    exclusiveCampaigns: {
      handler() {
        this.layout[5].data = this.exclusiveCampaigns || [];
      },
      deep: true,
      immediate: true
    },
    mainCampaigns: {
      handler() {
        this.layout[6].data = this.mainCampaigns || [];
      },
      deep: true,
      immediate: true
    }
  },

  data() {
    return {
      layout: [
        {
          x: 0,
          y: 0,
          w: 6,
          h: 7,
          i: '0',
          component: 'SlideShow'
        },
        {
          x: 6,
          y: 0,
          w: 2,
          h: 2.5,
          i: '1',
          title: 'conversion_value',
          icon: 'mdi-cash-fast',
          color: '#f42e2e',
          extras: {
            fullValue: '-'
          },
          component: 'SingleCard'
        },
        {
          x: 8,
          y: 0,
          w: 2,
          h: 2.5,
          i: '2',
          title: 'commission',
          icon: 'mdi-trending-up',
          color: '#17ccf3',
          extras: {
            fullValue: '-'
          },
          component: 'SingleCard'
        },
        {
          x: 10,
          y: 0,
          w: 2,
          h: 2.5,
          i: '3',
          title: 'conversion_amount',
          color: '#766BFB',
          icon: 'mdi-chart-bar',
          extras: {
            fullValue: '-'
          },
          component: 'SingleCard'
        },
        {
          x: 6,
          y: 2.5,
          w: 6,
          h: 8,
          i: '4',
          color: '#766BFB',
          icon: 'mdi-chart-bar',
          component: 'ListCampaignsAffiliate'
        },
        {
          x: 0,
          y: 3,
          w: 3,
          h: 6.7,
          i: '5',
          color: '#766BFB',
          component: 'ListCampaignsExclusive'
        },
        {
          x: 3,
          y: 3,
          w: 3,
          h: 6.7,
          i: '6',
          color: '#766BFB',
          component: 'ListCampaignsMain'
        },
        {
          x: 6,
          y: 10.5,
          w: 6,
          h: 6.7,
          i: '7',
          color: 'rgba(0, 0, 0, 0)',
          component: 'BarChartCard'
        }
      ]
    };
  },

  methods: {}
};
</script>
